<template>
  <div class="group-detail-member">
    
    <div v-if="canShowShareCodeDiv" class="py-4">
      <div v-if="!hasGroupShareCode" class="text-center">
        <button class="btn px-3 common-oval-btn dark fs-capation-12" @click="generateShareCodeClicked">生成小山石邀請碼</button>
      </div>

      <div v-else class="text-center">
        <p class="mb-0"><span class="font-weight-bold">小山石邀請碼：{{ groupData.shareCode }}</span> <a href="#" @click.prevent="copyShareCode">複製</a></p>
      </div>
    </div>

    <div class="team-members-number with-hr d-flex align-items-center">
      <div class="avatar-group">
        <div class="avatar circle-trail">
          <img :src="joinedMembers.owner.pic_url" alt="avatar">
        </div>
      </div>
      <div class="fs-body-14">
        <span>主辦人</span>
      </div>
    </div>

    <div class="team-members-number with-hr d-flex" v-for="(item, index) in joinedMembers.groupList" :key="index">
      <div class="avatar-group">
        <div class="avatar circle-trail">
          <img :src="item.user.pic_url" alt="avatar">
        </div>
        <div class="edit-link" v-if="item.user.serial === user.serial && !isExpired">
          <router-link :to="{ name: 'GroupDetailMemberJoin' }">編輯</router-link>
        </div>
      </div>
      <div class="no-permission fs-body-14 align-items-center d-flex" v-if="isExpired || !item.realName">
        <span>無瀏覽資料權限</span>
      </div>
      <!--								<div class="no-permission fs-body-14 align-items-center d-flex" v-if="!isExpired && !item.realName">-->
      <!--									<span>無瀏覽資料權限</span>-->
      <!--								</div>-->
      <div class="detail-list fs-body-14 align-items-center" v-if="!isExpired">
        <div class="detail-item cursor-pointer" v-if="item.realName" @click="getTextCopy($event)">
          <div class="item-title">姓名</div>
          <div class="item-desc" v-text="item.realName"></div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" v-if="item.phone" @click="getTextCopy($event)">
          <div class="item-title">電話</div>
          <div class="item-desc" v-text="item.phone"></div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" v-if="item.address" @click="getTextCopy($event)">
          <div class="w-100 d-flex flex-nowrap">
            <div class="item-title">地址</div>
            <div class="item-desc" v-text="(item.fullAddress && item.fullAddress.length>0)? item.fullAddress : item.address"></div>
          </div>
          <span class="success-alert"></span>
        </div>

        <div class="detail-item cursor-pointer" v-if="item.email" @click="getTextCopy($event)">
          <div class="item-title">Email</div>
          <div class="item-desc" v-text="item.email"></div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" v-if="item.personalId" @click="getTextCopy($event)">
          <div class="item-title">身分證字號</div>
          <div class="item-desc" v-text="item.personalId"></div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" v-if="item.birthday" @click="getTextCopy($event)">
          <div class="item-title">出生年月日</div>
          <div class="item-desc" v-text="item.birthday"></div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" v-if="item.emergencyName" @click="getTextCopy($event)">
          <div class="item-title">緊急聯絡人</div>
          <div class="item-desc" v-text="item.emergencyName"></div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" v-if="item.emergencyPhone" @click="getTextCopy($event)">
          <div class="item-title">緊急聯絡人電話</div>
          <div class="item-desc" v-text="item.emergencyPhone"></div>
          <span class="success-alert"></span>
        </div>

        <div class="detail-item cursor-pointer" style="display: none;">
          <div class="w-100 d-flex flex-nowrap">
            <div class="item-title">地址區域碼</div>
            <div class="item-desc" v-text="(item.cityCode && item.cityCode.length>0)? item.cityCode : ''"></div>
          </div>
          <span class="success-alert"></span>
        </div>
        <div class="detail-item cursor-pointer" style="display: none;">
          <div class="w-100 d-flex flex-nowrap">
            <div class="item-title">剩餘地址</div>
            <div class="item-desc" v-text="item.address"></div>
          </div>
          <span class="success-alert"></span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import setHideNav from "@/assets/js/setHideNav";
import {mapState} from "vuex";

export default {
  mixins: [setHideNav],
  name: 'GroupDetailMember',
  data() {
    return {
      readInfoBusyName: 'GroupDetailMember',
    };
  },
  props: {
    groupData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    journeyData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    joinedMembers: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  components: {
  },
  computed: {
    ...mapState(['user']),
    canShowShareCodeDiv() {
      return !this.isExpired && this.groupData.groupMasterSerial === this.user.serial;
    },
    hasGroupShareCode() {
      return this.groupData && this.groupData.shareCode && this.groupData.shareCode.length > 0;
    },
    isExpired: function() {
      const theDayAfterEndDate = moment(this.journeyData.endDate);
      theDayAfterEndDate.add(1, 'day');
      return moment().isAfter(theDayAfterEndDate);
    },
	},
  watch: {
  },
  async mounted() {
	},
  methods: {
    copyMsg(msg) {
      let node = document.createElement("span");
      node.innerText = msg;
      node.setAttribute('style', 'position:absolute;left:0;top:0;opacity:0;');
      document.body.appendChild(node);
      let selection = window.getSelection();
      selection.removeAllRanges();
      let range = document.createRange();
      range.selectNode(node);
      selection.addRange(range);

      try {
        var successful = document.execCommand('copy');
        var sysmsg = successful ? 'successful' : 'unsuccessful';
        console.log(sysmsg);
      } catch (err) {
        console.error(err);
      }

      selection.removeAllRanges();
      node.remove();
    },
    getTextCopy: function(event) {
      const target = event.currentTarget;
      let linkCopy = target.querySelector('.item-desc').innerText;
      this.copyMsg(linkCopy);
      const animated = target.querySelector('.success-alert');
      animated.classList.add('active');
      animated.onanimationend = () => {
        animated.classList.remove('active');
      }
    },
    generateShareCodeClicked() {
      this.$emit('generate-share-code-clicked')
    },
    copyShareCode() {
      this.copyMsg(this.groupData.shareCode);
      alert('已複製邀請碼');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.group-detail-member {
  @include smaller-than-medium {
    padding: 0 1rem;
  }
  .team-members-number {
    color: $color-bk-tp-85;
    padding: 36px 0;
    &.with-hr:not(:last-child) {
      border-bottom: 1px solid $color-black-200;
    }
    .no-permission {
      color: $color-bk-tp-25;
    }
    .avatar-group {
      flex: 0 0 auto;
      margin-right: 36px;
      .edit-link {
        text-align: center;
        margin-top: 8px;
      }
    }
  }
  .detail-list {
    flex: 1 1 auto;
    //height: 62px;
    .detail-item {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 12px;
      .item-title {
        flex: 0 0 auto;
        color: $color-bk-tp-25;
        padding-right: 12px;
      }
      .item-desc {
        flex: 1 1 auto;
        word-wrap: break-word;
      }
      .success-alert {
        position: absolute;
        left: 500%;
        white-space: nowrap;
        opacity: 0;
        //transform: translateY(-50%);
        &:before {
          content: '複製成功';
          color: $color-white;
          background: $color-black-800;
          font-size: $font-extra-small;
          padding: 3px 10px 3px;
          opacity: .7;
        }
      }
      .success-alert.active {
        top: -120%;
        left: 0;
        animation: alert 2s;
      }
    }
  }
}
</style>
